<div mat-dialog-title class="title">
    <mat-icon>info_outline</mat-icon>&nbsp;{{ 'Information' | translate }}
</div>
<mat-dialog-content>
    <div class="line">
        {{ text | translate }}
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Close' | translate }}</button>
</mat-dialog-actions>